<template>
    <div>
        <buttonlist
                @help="help"
                @opentable="opentable"
                @search="search"
                @reflash="reflash"
                @exps="exps"
                @execute="execute"
                ref="SetBtn"
        ></buttonlist>
        <wTable
                id="xpane-0"
                :data="dataSet"
                :loading="loading"
                queryData="V_ENG_TM_Line"
                :filter_language="['tm_status']"
                :header="tableHeader"
                :option="tableOption"
                @handleSelectionChange="handleSelectionChange"
                ref="singleTable"
        ></wTable>
        <!--<el-table
                id="xpane-0"
                :data="dataSet"
                v-loading="loading"
                :highlight-current-row="true"
                show-overflow-tooltip="true"
                border
                stripe
                size="mini"
                :height="tableHeight"
                header-row-class-name="headerclass"
                @selection-change="handleSelectionChange"
                style="width: 100%; margin-top:0px"
        >
            <el-table-column type="selection"></el-table-column>
            <el-table-column show-overflow-tooltip prop="part_code" :label="$t('getapi[112]')" fixed="left"></el-table-column>
            <el-table-column show-overflow-tooltip prop="part_version" :label="$t('getapi[149]')" fixed="left"></el-table-column>
            <el-table-column show-overflow-tooltip prop="item_code" :label="$t('getapi[876]')"></el-table-column>
            <el-table-column show-overflow-tooltip prop="item_name" :label="$t('getapi[574]')"></el-table-column>
            <el-table-column show-overflow-tooltip prop="item_assess" :label="$t('getapi[6404]')"></el-table-column>
            <el-table-column show-overflow-tooltip prop="tm_sort" :label="$t('getapi[6405]')"></el-table-column>
            <el-table-column show-overflow-tooltip prop="tm_name" :label="$t('getapi[6406]')"></el-table-column>
            <el-table-column show-overflow-tooltip prop="tm_date" :label="$t('getapi[6258]')"></el-table-column>
            <el-table-column show-overflow-tooltip prop="tm_status" :label="$t('getapi[6407]')">
                <template slot-scope="scope" >
                    {{exp(scope.row.tm_status)}}
                </template>
            </el-table-column>
            <el-table-column show-overflow-tooltip prop="user_name" :label="$t('getapi[6257]')"></el-table-column>
            <el-table-column show-overflow-tooltip prop="user_num" :label="$t('getapi[871]')"></el-table-column>
            <el-table-column show-overflow-tooltip prop="modify_person" :label="$t('getapi[6254]')"></el-table-column>
            <el-table-column show-overflow-tooltip prop="modify_time" :label="$t('getapi[6255]')"></el-table-column>
            <el-table-column show-overflow-tooltip prop="mail_time" :label="$t('getapi[6269]')"></el-table-column>
            <el-table-column show-overflow-tooltip prop="exclusively_id" :label="$t('getapi[111]')"></el-table-column>
        </el-table>-->
        <el-row class="page">
            <el-col :span="18">
                <el-pagination
                        @size-change="handleSizeChange"
                        @current-change="handleCurrentChange"
                        :page-sizes="[100, 200, 300, 400]"
                        :page-size="pageSize"
                        :pager-count="5"
                        layout="total, sizes, prev, pager, next, jumper"
                        :total="total"
                ></el-pagination>
            </el-col>
            <el-col :span="6">
                <div style="text-align: right;line-height: 30px;color: #545c64;font-size: 95%;">{{$t('getapi[7980]')}}:{{ DbTbNames }}</div>
            </el-col>
        </el-row>
        <serce :isVisible="isVisible" queryData="V_ENG_TM_Line" ref="ser" @getser="serclick"></serce>
        <ctable :isVisible="false" :title="$t('getapi[6535]')" queryData="V_ENG_TM_Line" tabNo="0" ref="ctab"
                @getctab="sortclick"></ctable>

        <el-dialog v-dialogDrag :visible.sync="isShowExecute" :title="$t('getapi[440]')" width="25%" :close-on-click-modal="false">
            <table>
                <tr>
                    <td>
                        {{$t('getapi[8742]')}}
                    </td>
                    <td>
                        <el-radio v-model="tm_status" label="0" @change="changeStatus">{{$t('getapi[866]')}}</el-radio>
                        <el-radio v-model="tm_status" label="1" @change="changeStatus">{{$t('getapi[2052]')}}</el-radio>
                    </td>
                </tr>
                <tr>
                    <td>
                        {{$t('getapi[143]')}}
                    </td>
                    <td>
                        <el-input v-model="remark" :disabled="tm_status == 0"></el-input>
                    </td>
                </tr>
            </table>

            <span slot="footer" class="dialog-footer">
				<el-button size="mini" @click="isShowExecute = false">{{$t('getapi[2054]')}}</el-button>
				<el-button size="mini" type="primary" @click="confirmExecute">{{$t('getapi[1146]')}}</el-button>
			</span>
        </el-dialog>
    </div>
</template>

<script>
    import Common from '@/components/Common';
    import Array from '@/components/Array';
    export default {
        name:'tminfo',
        computed: {
            tableOption() {
                return {
                    border: true,
                    height: this.$windowSize.tableHeight2,
                    maxHeight: this.$windowSize.tableHeight2,
                }
            },
            tableHeight(){
                return this.$windowSize.tableHeight3
            }
        },
        data() {
            return {
                tableHeader:[],
                dataSet: [], // 主表数据
                isVisible: false, // 查询列表是否显示
                queryData: [], // 查询数组
                userData: [], // 用户信息
                DbTbNames: '',
                pageIndex: 1, // 当前页
                pageSize: this.$http.getPageSize('tminfo'), // 当前页数据量
                SelectIndexs: 0, //当前页面
                total: 0, // 数据总量
                loading: false, // 主表加载状态
                selectData: [],
                isShowExecute: false,
                tm_status: '1',
                remark: '',
                scrollTop:0,
            };
        },
        mounted: function() {
            let that = this;
            that.colsort();
            that.userData = sessionStorage.getItem('userData');
            that.authority();
            that.$nextTick(function () {
                that.$processdata.initForm()
            })
        },
        activated () {
            let that = this
            setTimeout(() => {
                that.$refs.singleTable.$refs.singleTable.bodyWrapper.addEventListener('scroll', (res) => {
                    that.scrollTop = res.target.scrollTop
                },false)
            }, 5000);
            // 路由跳转回来滚动到离开时的位置
            this.$nextTick(()=> {
                setTimeout(() => {
                    this.$refs.singleTable.$refs.singleTable.bodyWrapper.scrollTop =this.scrollTop;
                }, 13)
            })

        },
        methods: {
            colsort() {
                let that = this;
                that.$loadviewfields.Fileds('V_ENG_TM_Line', 0, PFileds => {
                    that.tableHeader = PFileds;
                });
            },
            sortclick(val) {
                if (val == 1) {
                    this.colsort();
                }
            },
            // 修改表格顺序
            opentable() {
                this.$refs.ctab.clearInputs(true);
            },
            help(){
                this.$refs.SetBtn.showHelp(this.$options.name,this.$t("getapi[6535]"),this.$t("getapi[18]"));
            },
            authority() {
                let that = this;
                if(that.$loadviewfields.isEnableHelp(this.$options.name) == 1){
                    that.$refs.SetBtn.SetOneBtnEnable('help',true);
                }
                that.$refs.SetBtn.SetOneBtnEnable('ctabel', true);
                if (that.total > 0) {
                    that.$refs.SetBtn.SetButtonEnable('search,refresh,export');
                } else {
                    that.$refs.SetBtn.SetButtonEnable('search,refresh');
                }
                if(that.selectData.length>0){
                    that.$refs.SetBtn.SetOneBtnEnable('execute', true)
                }
            },
            handleSizeChange(val) {
                this.pageSize = val;
                this.$http.savePageSize('tminfo',val)
                this.getView();
                this.authority();
            },
            handleCurrentChange(val) {
                this.pageIndex = val;
                this.getView();
                this.authority();
            },
            // 查询
            search() {
                let that = this;
                that.isVisible = true;
                that.$refs.ser.clearInput(that.isVisible, 'V_ENG_TM_Line');
            },
            //获取查询条件
            serclick(val) {
                this.queryData = val;
                this.confirmGetView();
            },
            // 确认获取数据
            confirmGetView() {
                let that = this;
                that.pageIndex = 1
                that.isVisible = false;
                that.getView();
            },
            // 数据一览
            getView() {
                let that = this;
                that.loading = true;
                let datac = [];
                for (let i = 0; i < that.queryData.length; i++) {
                    datac.push({
                        query_Condition: that.queryData[i].query_Condition,
                        query_field_type: that.queryData[i].Query_Field_Type,
                        query_field_name: that.queryData[i].Query_Field_Name,
                        query_sort: that.queryData[i].query_sort,
                        row_sign: that.queryData[i].row_sign
                    });
                }
                let data = {
                    PageIndex: that.pageIndex,
                    PageSize: that.pageSize,
                    SelectIndex: that.SelectIndexs,
                    Param: datac
                };
                that.$http.urlpost('/Eng/TMView/GetTMLineView', data, function(res) {
                    if (res.Success == 1) {
                        that.dataSet = res.DataContent;
                        that.total = res.Totals;
                        that.loading = false;
                        that.DbTbNames = res.DbTbNames;
                        that.authority();
                    }
                    that.$nextTick(function(){
                        that.$processdata.initForm(that.SelectIndexs)
                    });
                });
            },
            // 刷新
            reflash() {
                let that = this;
                that.getView();
            },
            // 导出
            exps() {
                let that = this;
                let datac = [];
                for (let i = 0; i < that.queryData.length; i++) {
                    datac.push({
                        query_Condition: that.queryData[i].query_Condition,
                        query_field_type: that.queryData[i].Query_Field_Type,
                        query_field_name: that.queryData[i].Query_Field_Name,
                        query_sort: that.queryData[i].query_sort,
                        row_sign: that.queryData[i].row_sign
                    });
                }
                let parm = {
                    PageIndex: that.PageIndex,
                    PageSize: that.PageSize,
                    SelectIndex: that.SelectIndex,
                    Ids: '',
                    Param: datac
                };
                that.$refs.SetBtn.SetOneBtnEnable('exps',false);
                that.$http.urlpost('/Eng/TMView/GetTMLineViewToExecl', parm, function(res) {
                    that.$refs.SetBtn.SetOneBtnEnable('exps',true);
                    if (res.Success == 1) {
                        let hrefurl = Common.Url + res.DataContent.URL;
                        window.open(hrefurl);
                    }
                });
            },
            handleSelectionChange(val){
                let that = this;
                that.selectData = []
                for (let i = 0; i < val.length; i++) {
                    that.selectData.push(val[i])
                }
                that.authority()
            },
            execute(){
                let that = this
                that.isShowExecute = true
                that.tm_status = '1'
                that.remark = ''
            },
            changeStatus(val){
                let that = this
                if(val == 0){
                    that.remark = ''
                }
            },
            confirmExecute(){
                let that = this
                let parm = {
                    list: [],
                    TM_STATUS: that.tm_status,
                    Remark: that.remark,
                    LangType: that.$processdata.getLang()
                }
                for(let i = 0;i< that.selectData.length;i++){
                    parm.list = [...parm.list,that.selectData[i].exclusively_id]
                }
                that.$http.urlpost('/Eng/TMView/Audit', parm, function(res) {
                    if (res.Success == 1) {
                        that.$message.success(that.$processdata.explainCallbackMsg(res.Msg));
                        that.isShowExecute = false
                        that.getView()
                    }
                });
            },
            exp(val){
                let that = this
                if(val == 0){
                    return '否'
                } else if (val == 1){
                    return '是'
                } else if(val == 3){
                    return '待处理'
                } else {
                    return ''
                }
            },
        }
    };
</script>

<style scoped lang="less">
    table {
        border-collapse: separate;
        border-spacing: 0px 5px;
        td {
            padding-left: 3px;
            white-space: pre;
        }
    }
</style>
